import { table } from "../models.model";

export const AJUSTADA_AIRAC: table = {
  columnas: [
    'Plazos',
    'de 0 a 15 días',
    'de 0 a 30 días',
    'de 0 a 60 días',
    'de 0 a 90 días'
  ],
  filas: [
    {
      type: 'titulo',
      bandas: [1,1,1,1],
      descripcion: 'Activos Líquidos Ajustados'
    },{
      type: 'operacion',
      id: 'OPERACION_01',
      bandas: [1,1,1,1],
      descripcion: 'Efectivo',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consulta', valor: 'disponibilidades_01.0'}
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'disponibilidades_01.1'}
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'disponibilidades_01.2'}
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'disponibilidades_01.3'}
          ]
        },
      ],
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_00',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: 'Encaje legal requerido por el Banco Central',
      visible: true,
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_01',
      bandas: [1,1,1,1],
      descripcion: 'Interbancarios netos',
      sumar: ['CEROS_01', 'OPERACION_02'],
      expandible: true,
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_01',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: '\tOtorgados',
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_02',
      bandas: [1,1,1,1],
      descripcion: '\tRecibidos',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consulta', valor: 'fondos_01.0'}
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'fondos_01.1'}
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'fondos_01.2'}
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'fondos_01.3'}
          ]
        },
      ],
      visible: true,
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_02',
      bandas: [1,1,1,1],
      descripcion: 'Recuperación de créditos',
      sumar: ['OPERACION_03','CEROS_03', 'CEROS_04'],
      expandible: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_03',
      bandas: [1,1,1,1],
      descripcion: '\tCartera "A" y "B"',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consulta', valor: 'cartera_01.0'}
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
          ]
        },
      ],
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_03',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: '\tEstimación cartera "C" de mayores deudores comerciales',
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_04',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: '\tEstimación de tarjeta de crédito "A" y "B"',
      visible: true,
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_03',
      bandas: [1,1,1,1],
      descripcion: 'Titulos con pactos de reventa / recompra (neto)',
      sumar: ['CEROS_05', 'CEROS_06'],
      expandible: true,
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_05',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: '\tCompra de títulos con pacto de reventa',
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_06',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: '\tTítulos valores vendidos con pacto de recompra',
      visible: true,
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_04',
      bandas: [1,1,1,1],
      descripcion: 'Inversiones',
      sumar: ['CEROS_08', 'OPERACION_04'],
      expandible: true,
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_08',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: '\tInversiones en el Banco Central y Ministerio de Hacienda',
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_04',
      bandas: [1,1,1,1],
      descripcion: '\tInversiones en instituciones financieras del pais',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consulta', valor: 'inversiones_01.0'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'inversiones_02.0'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'inversiones_03.0'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'valores_01.0'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'valores_02.0'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consulta', valor: 'inversiones_01.1'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'inversiones_02.1'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'inversiones_03.1'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'valores_01.1'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'valores_02.1'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consulta', valor: 'inversiones_01.2'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'inversiones_02.2'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'inversiones_03.2'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'valores_01.2'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'valores_02.2'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'consulta', valor: 'inversiones_01.3'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'inversiones_02.3'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'inversiones_03.3'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'valores_01.3'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'valores_02.3'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },
      ],
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_07',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: 'Otras Inversiones líquidas en sector privado no financiero',
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_09',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: 'Encaje legal a liberarse',
      visible: true,
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_05',
      bandas: [1,1,1,1],
      descripcion: 'Total de activos líquidos',
      sumar: [
        'CEROS_00',
        'OPERACION_01',
        'SUBTOTAL_01',
        'SUBTOTAL_02',
        'SUBTOTAL_03',
        'SUBTOTAL_04',
        'CEROS_07',
        'CEROS_09'
      ],
      visible: true,
    },{
      type: 'blank',
      id: '1',
      bandas: [0,0,0,0],
    },{
      type: 'titulo',
      bandas: [1,1,1,1],
      descripcion: 'Pasivos inmediatos'
    },{
      type: 'operacion',
      id: 'SUBTOTAL_05',
      bandas: [1,1,1,1],
      descripcion: 'Porción volatil de depósitos del público',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consulta', valor: 'depositos_01.0'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'depositos_01.1'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'depositos_01.2'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'depositos_01.3'},
          ]
        },
      ],
      visible: true,
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_06',
      bandas: [1,1,1,1],
      descripcion: 'Resto de pasivos según vencimiento residual',
      sumar: [
        'OPERACION_07',
        'OPERACION_08',
        'OPERACION_09',
      ],
      expandible: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_07',
      bandas: [1,1,1,1],
      descripcion: '\tCargos por pagar',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consulta', valor: 'fondos_01.0'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'depositos_03.0'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'financiamientos_01.0'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'fondos_01.1'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'depositos_03.1'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'financiamientos_01.1'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'fondos_01.2'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'depositos_03.2'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'financiamientos_01.2'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'fondos_01.3'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'depositos_03.3'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'financiamientos_01.3'},
          ]
        },
      ],
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_08',
      bandas: [1,1,1,1],
      descripcion: '\tObligaciones a la vista',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consulta', valor: 'obligaciones_01.0'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'pasivos_02.0'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'obligaciones_01.1'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'pasivos_02.1'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'obligaciones_01.2'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'pasivos_02.2'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'obligaciones_01.3'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'pasivos_02.3'},
          ]
        },
      ],
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_09',
      bandas: [1,1,1,1],
      descripcion: '\tOtros pasivos',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consulta', valor: 'fondos_02.0'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'obligaciones_02.0'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'fondos_02.1'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'obligaciones_02.1'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'fondos_02.2'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'obligaciones_02.2'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'fondos_02.3'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'consulta', valor: 'obligaciones_02.3'},
          ]
        },
      ],
      visible: true,
    },{
      type: 'ceros',
      id: 'CEROS_10',
      bandas: [0,0,0,0],
      calculo: [1,1,1,1],
      descripcion: 'Contingencias clasificadas "D1", "D2" y "E"',
      visible: true,
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_07',
      bandas: [1,1,1,1],
      descripcion: 'Total pasivos inmediatos',
      sumar: [
        'SUBTOTAL_05',
        'SUBTOTAL_06',
        'CEROS_10'
      ],
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_10',
      bandas: [1,1,1,1],
      descripcion: 'Razón de liquidez ajustada',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_05'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 100},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_05'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 100},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_05'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 100},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_05'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 100},
          ]
        },
      ],
      suma: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_11',
      bandas: [1,1,1,1],
      descripcion: 'Posición de liquidez ajustada',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'SUBTOTAL_05'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'SUBTOTAL_05'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'SUBTOTAL_05'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'SUBTOTAL_05'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
          ]
        },
      ],
      suma: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_12',
      bandas: [1,1,1,1],
      descripcion: 'Liquidez mínima requerida',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 0.8}
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 0.8}
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 0.7}
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'consulta', valor: 'SUBTOTAL_07'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 0.7}
          ]
        },
      ],
      suma: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_13',
      bandas: [1,1,1,1],
      descripcion: 'Sobrante (+) faltante (-) liquidez',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'SUBTOTAL_07'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'SUBTOTAL_12'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'SUBTOTAL_07'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'SUBTOTAL_12'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'SUBTOTAL_07'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'SUBTOTAL_12'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'SUBTOTAL_07'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'consulta', valor: 'SUBTOTAL_12'},
          ]
        },
      ],
      suma: true,
      visible: true,
    }
  ]
}